import './DeliveryDetails.scss'

import React, { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { isAgentLogged, isClubOneLogged, isClubOneTabSelected } from '../../../selectors/selectors'
import ClubOneSsoLoginLink from '../../common/ClubOneSsoLoginLink'
import LoggedInForm from './Form/LoggedInForm'
import NotLoggedInForm from './Form/NotLoggedInForm'

function DeliveryDetails(props, ref) {
  const { t } = useTranslation()

  const clubOneLogged = useSelector(isClubOneLogged)
  const clubOneTabSelected = useSelector(isClubOneTabSelected)
  const agentLogged = useSelector(isAgentLogged)

  return (
    <section className="delivery-details" ref={ref}>
      <div className="delivery-details-title">{t('deliveryDetails.title')}</div>
      <div className="content">
        <div className="text">{t('deliveryDetails.clubOneAnonymous.text')}</div>
        {clubOneTabSelected && !clubOneLogged && <ClubOneSsoLoginLink />}
        {clubOneLogged || agentLogged ? <LoggedInForm /> : <NotLoggedInForm />}
      </div>
    </section>
  )
}

export default forwardRef(DeliveryDetails)
